
import servicesQuery from "@/apollo/queries/pages/services";
import locomotiveScrollMixin from "@/mixins/locomotiveScrollMixin";
import previewModeMixin from '@/mixins/previewModeMixin';

export default {
  name: 'services',
  colorMode: 'light',
  mixins: [locomotiveScrollMixin, previewModeMixin],
  data() {
    return {
      sT: null,
      services: {
        data: [],
      },
    };
  },
  computed: {
    isLocoScrollInitialized() {
      return this.$store.state.isLocomotiveScrollInitialized;
    }
  },
  watch: {
    isLocoScrollInitialized(newValue) {
      if (newValue) {
        this.initScrollTriggerAnimation();
      }
    }
  },
  mounted() {
    // Check on mount as well, in case the value is already true when the component mounts
    if (this.isLocoScrollInitialized) {
      this.initScrollTriggerAnimation();
    }
  },
  methods: {
    initScrollTriggerAnimation() {
      if (process.client) {
        const sideBar = this.$refs.sideBar;
        this.sT = this.$ScrollTrigger.create({
          trigger: sideBar.parentElement, // Use the parent as the trigger
          start: `top center${this.$device.isMobileOrTablet ? '' : '+=160'}`, // Start when the top of the parent reaches the bottom of the viewport
          end: "bottom top", // End when the bottom of the parent reaches the top of the viewport
          scrub: 0.3,
          pin: this.$refs.sideBar,
          anticipatePin: 1, // add this line
          scroller: window.matchMedia("(max-width: 768px)").matches ? null : "[data-scroll-container]",
        });
      }
    },
  },
  async asyncData({app, store}) {
    const previewMode = store.state.previewMode;
    const {default: MarkdownIt} = await import('markdown-it')
    const md = new MarkdownIt({html: true});

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    const response = await app.apolloProvider.defaultClient.query({
      query: servicesQuery,
      variables: {
        locale: app.i18n.locale,
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    })

    // Process Markdown for each service description
    response.data.services.data.attributes.services = response.data.services.data.attributes.services.map(service => {
      if (service.description) {
        service.description = md.render(service.description);
      }
      return service;
    });

    return {
      services: response.data.services,
      previewMode
    }
  },
};
